module.exports = "pegasus/assets/blocks/column-18-tech.png";